//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';
//Material-ui
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
import moment from 'moment';
import { withAlert } from 'react-alert';

import PartPageTitle from './PartPageTitle';


class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.itemYear　= [];
    let nowYear = Number(moment().format('Y'));
		let startYearOffset = 90;
		let endYearOffset = 18;
    for (let i = (nowYear - startYearOffset); i <= (nowYear - endYearOffset); i++) {
      let year = String(i);
			this.itemYear.push(year);
    }

    this.itemMonth　= [];
    for (let i = 1; i <= 12; i++) {
      let month = String(i).padStart(2, "0");
			this.itemMonth.push(month);
    }

    this.itemDay　= [];
    for (let i = 1; i <= 31; i++) {
      let day = String(i).padStart(2, "0");
			this.itemDay.push(day);
    }

    this.state = {
      enable: false,
      enableError: null,
      year: this.props.my.profile.userdata_birthday.substr( 0, 4 ),
      month: this.props.my.profile.userdata_birthday.substr( 4, 2 ),
      day: this.props.my.profile.userdata_birthday.substr( 6, 2 ),
      newName: this.props.my.profile.userdata_name,
      newNameError: null,
      newNameSaveDialog: false,
      saveSnackVisible: false,
    }
	}

  componentDidMount() {
    document.title = '生年月日の変更 - パートナーズ';
    this._birthdayEditCheck();
  }

  _birthdayEditCheck() {
    if (this.props.my.proof.person === 1) {
      this.setState({ enable: false});
      this.setState({ enableError: '本人証明書が提出済みの為、変更できません。' });
    }
    else {
      var params = new URLSearchParams();
      params.append('ULIC', Cookies.get('ULIC'));
      params.append('ULPC', Cookies.get('ULPC'));
      params.append('type', 'check');
      return axios.post(config.apiUri + "member/settingBirthdayEdit.php", params, {
        timeout: 10000
      })
      .then((res) => {
        if (res.data.bool) {
          this.setState({ enable: true});
        }
        else {
          this.setState({ enable: false});
          this.setState({ enableError: res.data.comment });
        }
      })
      .catch((err) => {
        alert( config.apiErrComment );
      })
    }
  }



  _submit() {
    this.props.alert.show("生年月日を変更しますか？(再変更できません)", {
      title: "生年月日の変更",
      closeCopy: "キャンセル",
      actions: [
        {
          copy: "変更する",
          onClick: () => this.props.settingBirthdayEdit(this.state.year+this.state.month+this.state.day, () => this.props.history.push('/setting/') )
        }
      ]
    });

  }

  render() {
    let birthdayValid;
    let birthdayError;
    if (this.state.year+this.state.month+this.state.day === this.props.my.profile.userdata_birthday) {
      birthdayValid = false;
    }
    else if (moment(this.state.year + '-' + this.state.month + '-' + this.state.day).isValid() === false) {
      birthdayError = '生年月日が正しくありません';
      birthdayValid = false;
    }
    else {
      birthdayError = null;
      birthdayValid = true;
    }


    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'生年月日の変更'}
          onback={ '/setting/' }
        />

        <div style={{maxWidth:'400px', margin:'auto'}}>
          {
            (this.state.enable) ?
            <div>
              <div style={{padding:'10px'}}>

                <ul style={{paddingLeft:'20px'}}>
                  生年月日は一度だけ変更可能です。再変更できませんのでご注意ください。
                </ul>


                <div style={{padding:'10px'}}>
                  <div
                    style={{
                      display:'flex',
                      flexDirection:'row',
                      alignItems:'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FormControl variant="outlined">
                      <Select
                        value={this.state.year}
                        onChange={ (event) => this.setState({year: event.target.value}) }
                      >
                      {
                        this.itemYear.map((value, index) =>
                          <MenuItem key={index} value={value}>{value}</MenuItem>
                        )
                      }
                      </Select>
                    </FormControl>
                    年
                    <FormControl variant="outlined">
                      <Select
                        value={this.state.month}
                        onChange={ (event) => this.setState({month: event.target.value}) }
                      >
                      {
                        this.itemMonth.map((value, index) =>
                          <MenuItem key={index} value={value}>{value}</MenuItem>
                        )
                      }
                      </Select>
                    </FormControl>
                    月
                    <FormControl variant="outlined">
                      <Select
                        value={this.state.day}
                        onChange={ (event) => this.setState({day: event.target.value}) }
                      >
                      {
                        this.itemDay.map((value, index) =>
                          <MenuItem key={index} value={value}>{value}</MenuItem>
                        )
                      }
                      </Select>
                    </FormControl>
                    日
                  </div>
                  <div style={{color:'red'}}>{birthdayError}</div>
                </div>
              </div>

              <div align='center' style={{padding:'10px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{minWidth:'240px'}}
                  onClick={ () => this._submit() }
                  disabled={ (birthdayValid === true) ? false : true }
                >
                  <span style={{fontSize:'1.4em'}}>変更する</span>
                </Button>
              </div>
            </div>:
            <div style={{padding:'10px'}}>
              <div>{this.state.enableError}</div>
            </div>
          }
        </div>

      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withAlert()(Comp));
